module.exports = __webpack_public_path__ + "static/media/pc.b566a6a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/servicios/pc.svg
// module id = 169
// module chunks = 0